import UKFlag from "../assets/img/top-bar-icons/flag-uk.svg";
import DEFlag from "../assets/img/top-bar-icons/flag-de.svg";
import ESFlag from "../assets/img/top-bar-icons/flag-es.svg";
import FRFlag from "../assets/img/top-bar-icons/flag-fr.svg";
import PTFlag from "../assets/img/top-bar-icons/flag-pt.svg";

export const languages = [
  {
    code: 'en',
    name: 'English',
    flag: UKFlag,
    flagCode: 'uk'
  },
  {
    code: 'de',
    name: 'German',
    flag: DEFlag,
    flagCode: 'de'
  },
  {
    code: 'es',
    name: 'Spanish',
    flag: ESFlag,
    flagCode: 'es'
  },
  {
    code: 'fr',
    name: 'French',
    flag: FRFlag,
    flagCode: 'fr'
  },
  {
    code: 'pt',
    name: 'Portuguese',
    flag: PTFlag,
    flagCode: 'pt'
  }
]; 